import React, { useEffect, useState }
from 'react';

const Rss = () => {
    const API_URL = process.env.REACT_APP_SERVICE_API_URL;
    const [rss, setRss] = useState({chanelLink: '', chanelTitle: '', items: []});
    useEffect(() => {
        const fetchMenuItems = async () => {
            try {
                const response = await fetch(`${API_URL}/common/get_rss.php`);
                const data = await response.json();
                setRss(data);
            } catch (error) {
                console.error('Error fetching menu:', error);
            }
        };
        fetchMenuItems();
    }, []);
    return (
            <>
            <h1>RSS</h1>
            <p><a href={rss.chanelLink}>{rss.chanelTitle}</a></p>
            <ul>
                {rss.items.map((item, index) => {
                                return (
                                        <li key={index}><a href={item.itemLink}>{item.itemTitle}</a>&nbsp;[{item.itemDate}]<br />
                                            {item.itemDesc}                                    
                                        </li>
                                        );
                            })}
            
            </ul>
            <hr />
            <i>RSS url: <a href="https://www.mbkegy.hu/mbkegy.rss" target="newWin">https://www.mbkegy.hu/mbkegy.rss</a></i>            
            </>
            );
};

export default Rss;